const path = require('path')

module.exports = {
  imageSizes: [90, 200, 400, 800, 1200, 1600, 2400],
  locales: {
    sv: {
      path: '/sv',
      title: 'Swedish',
      centraCode: 'sv',
      centraCountry: 'se',
      default: true,
      tlds: ['se'], // Top-level domains connected to this locale
    },
    nb: {
      path: '/no',
      title: 'Norwegian',
      centraCode: 'no',
      centraCountry: 'no',
      tlds: ['no'],
    },
  },
  namespace: 'strings', // Must match field name in Contentful
  siteName: '',
  globalSiteName: 'Global',
  contentfulModels: {
    startpage: {
      json: 'src/json/startpages.json',
    },
    siteConfig: {
      json: 'src/json/siteconfigs.json',
    },
    footerConfig: {
      json: 'src/json/footerconfigs.json',
    },
    menu: {
      json: 'src/json/menus.json',
    },
    infoPage: {
      component: path.resolve('./src/templates/information.tsx'),
    },
    brandLandingPage: {
      component: path.resolve('./src/templates/brand.tsx'),
    },
    brandConfig: {
      json: 'src/json/brands.json',
    },
    faqPage: {
      component: path.resolve('./src/templates/faq.tsx'),
    },
    productInfo: {
      json: 'src/json/productinfo.json',
    },
  },
  contentful: {
    accessToken: 'TTBbwZZMItSG3nYTxlFezld4qw2SDyMpxYJE8PIbns8',
    environment: 'master',
    space: '3sdtigs47xkj',
  },
  // centra: {
  //   url: 'https://selectedbrands.centraqa.com/api/shop/',
  //   auth: 'ZuL+TgN5C9LK8YXLNA-aEGewi0WhUwR-',
  //   checkoutApi: {
  //     url: 'https://selectedbrands.centraqa.com/api/checkout-api/',
  //   },
  // },
  centra: {
    url: 'https://selectedbrands.centra.com/api/shop/',
    auth: 'kyrfksRMQydKN7812HNOeYAS8b0dzlM0',
    checkoutApi: {
      url: 'https://selectedbrands.centra.com/api/checkout/',
    },
  },
  sentry: {
    DSN: 'https://edf3b1690ca34492a2efe0d6bada65ed@sentry.io/1483647',
  },
}
